import { RM04_03 } from "./RM04_03";

export const RM04_02 = {
  selectedValueColumn: "DrillKey",
  selectedTitle: "District",
  visual: [
    {
      columns: 12,
      rows: 2,
      visual: {
        id: 1,
        type: "advancedTable",
        colorTheme: "colorTheme1",
        title: "District",
        binding: {
          data: {
            columns: [
              {
                name: "Manager Name",
                columnName: "FSName",
                width: "300px",
                align: "left",
                sortable: true,
              },
              {
                name: "District",
                columnName: "DistrictName",
                width: "300px",
                align: "left",
                sortable: true,
              },
              {
                name: "Number Of Branches",
                columnName: "NumberOfBranches",
                width: "300px",
                align: "center",
                sortable: true,
              },
            ],
            title: "DistrictName",
            endpoint: "RM04.2",
            parameters: [
              { key: "CycleCode", value: "CP1" },
              { key: "CycleYear", value: "2026" },
              { key: "RegionCode", value: "" },
              { key: "DrillKey", value: "" },
            ],
          },
          context: {
            point: {
              onClick: RM04_03,
            },
          },
        },
      },
    },
  ],
};
